import { Injectable } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Entry } from 'contentful';
import { ContentFulModel } from 'src/app/shared/models/contentfulmodel';
import { BehaviorSubject } from 'rxjs';
import { PageId } from 'src/app/shared/utilities/pageids.enum';
import { MetaService } from 'src/app/shared/services/meta.service';

@Injectable({
  providedIn: 'root',
})
export class NewsroompageService {
  constructor(
    private contentful: ContentfulService,
    private meta: MetaService
  ) {}

  newsroomData: any;
  articleData: any;

  private newsroomHeroSubject$ = new BehaviorSubject<any>(null);
  public newsroomHero$ = this.newsroomHeroSubject$.asObservable();
  private newsroomSubject$ = new BehaviorSubject<any>(null);
  public newsroom$ = this.newsroomSubject$.asObservable();
  private articlePageDataSubject$ = new BehaviorSubject<any>(null);
  public articlePageData$ = this.articlePageDataSubject$.asObservable();
  private getStartedSubject$ = new BehaviorSubject<any>(null);
  public getStarted$ = this.getStartedSubject$.asObservable();

  getnewsroomData() {
    this.contentful
      .getEntries(
        Object.assign({
          content_type: PageId.newsroomPage,
          include: 10,
        })
      )
      .then(res => {
        let mod = res.items as Entry<any>[];
        this.newsroomData = mod[0].fields;
        const heroPanel = this.newsroomData.heroPanel.fields;
        if (heroPanel) {
          this.newsroomHeroSubject$.next(heroPanel);
        }
        const newsroom = this.newsroomData;
        if (newsroom) {
          this.newsroomSubject$.next(newsroom);
        }
        const getStarted = this.newsroomData.gettingStartedPanel.fields;
        if (getStarted) {
          this.getStartedSubject$.next(getStarted);
        }
      });
  }

  getNewsListBySearch(query: string): Promise<Entry<any>[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          access_token: PageId.accessToken,
          include: 10,
          content_type: PageId.newsroomArticle,
          query: query,
        })
      )
      .then(res => res.items);
  }

  getNewsListByTag(query: string): Promise<Entry<any>[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          access_token: PageId.accessToken,
          include: 10,
          content_type: PageId.newsroomArticle,
          'fields.category': query,
        })
      )
      .then(res => res.items);
  }

  getNewsByID(query: string): Promise<Entry<any>[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          access_token: PageId.accessToken,
          include: 10,
          content_type: PageId.newsroomArticle,
          'fields.newsroomArticleId': query,
        })
      )
      .then(res => res.items);
  }

  getArticleData(id: string) {
    this.getNewsByID(id).then(data => {
      this.articleData = data;
      if (this.articleData) {
        this.articlePageDataSubject$.next(this.articleData);
      }
    });
  }
}
